export default "/images/tickets-active-light.svg?5bb6652556f8ddd3bf13bb242b8f11b0";